import { render, staticRenderFns } from "./UploadFile1.vue?vue&type=template&id=130147dc&scoped=true&"
import script from "./UploadFile1.vue?vue&type=script&lang=js&"
export * from "./UploadFile1.vue?vue&type=script&lang=js&"
import style0 from "./UploadFile1.vue?vue&type=style&index=0&id=130147dc&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "130147dc",
  null
  
)

export default component.exports